import React, { useState, useEffect } from 'react';
import axios from 'axios';

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handle = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handle);
    return () => window.removeEventListener('resize', handle);
  }, []);
  return isMobile;
};

const FragranceModal = ({ item, onClose, onDelete, token }) => {
    const isMobile = useIsMobile();
    const [confirmDelete, setConfirmDelete] = useState(false);
    const [editingBottle, setEditingBottle] = useState(false);
    const [newPct, setNewPct] = useState(item.bottle_percentage);
    const [editingSize, setEditingSize] = useState(false);
    const [newSize, setNewSize] = useState(item.bottle_size_ml || '');

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) onClose();
    };

    const parseNotes = (notes) => {
        if (!notes) return [];
        if (Array.isArray(notes)) return notes;
        try { return JSON.parse(notes); } catch { return [notes]; }
    };

    const topNotes = parseNotes(item.top_notes);
    const midNotes = parseNotes(item.middle_notes);
    const baseNotes = parseNotes(item.base_notes);
    const seasons = Array.isArray(item.season) ? item.season : [];
    const occasions = Array.isArray(item.occasion) ? item.occasion : [];

    const handleSavePct = async () => {
        try {
            await axios.patch(
                `${process.env.REACT_APP_API_URL}/api/library/${item.id}`,
                { bottle_percentage: newPct },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            item.bottle_percentage = newPct;
            setEditingBottle(false);
        } catch (err) { console.error(err); }
    };

    const handleSaveSize = async () => {
        try {
            await axios.patch(
                `${process.env.REACT_APP_API_URL}/api/library/${item.id}`,
                { bottle_size_ml: newSize },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            item.bottle_size_ml = parseInt(newSize);
            setEditingSize(false);
        } catch (err) { console.error(err); }
    };

    const ratingDots = (value, max = 5) =>
        Array.from({ length: max }, (_, i) => (
            <span key={i} style={{ display: 'inline-block', width: '6px', height: '6px', borderRadius: '50%', background: i < value ? '#c9a96e' : '#2a2a2a', marginRight: '5px' }} />
        ));

    const tag = (label, i) => (
        <span key={i} style={{ display: 'inline-block', fontFamily: 'Jost, sans-serif', fontSize: '0.6rem', letterSpacing: '0.15em', textTransform: 'uppercase', color: '#a09890', border: '1px solid #2a2a2a', padding: '4px 10px', marginRight: '6px', marginBottom: '6px' }}>{label}</span>
    );

    const sectionLabel = {
        fontFamily: 'Jost, sans-serif', fontSize: '0.6rem', fontWeight: 400,
        letterSpacing: '0.35em', textTransform: 'uppercase', color: '#c9a96e', marginBottom: '14px',
    };
    const noteGroupLabel = {
        fontFamily: 'Jost, sans-serif', fontSize: '0.6rem', fontWeight: 300,
        letterSpacing: '0.2em', textTransform: 'uppercase', color: '#665e58', marginBottom: '8px',
    };
    const noteText = { fontFamily: 'Jost, sans-serif', fontSize: '0.78rem', fontWeight: 300, color: '#f5f0eb', marginBottom: '5px', display: 'block' };
    const ratingLabel = { fontFamily: 'Jost, sans-serif', fontSize: '0.75rem', fontWeight: 300, color: '#a09890' };

    const pad = isMobile ? '24px 20px' : '32px 40px';
    const headerPad = isMobile ? '24px 20px 20px' : '36px 40px 28px';

    const NotesContent = () => (
        <>
            <p style={sectionLabel}>Fragrance Notes</p>
            <div style={{ display: 'flex', gap: isMobile ? '16px' : '24px' }}>
                {topNotes.length > 0 && <div style={{ flex: 1 }}><p style={noteGroupLabel}>Top</p>{topNotes.map((n, i) => <span key={i} style={noteText}>{n}</span>)}</div>}
                {midNotes.length > 0 && <div style={{ flex: 1 }}><p style={noteGroupLabel}>Heart</p>{midNotes.map((n, i) => <span key={i} style={noteText}>{n}</span>)}</div>}
                {baseNotes.length > 0 && <div style={{ flex: 1 }}><p style={noteGroupLabel}>Base</p>{baseNotes.map((n, i) => <span key={i} style={noteText}>{n}</span>)}</div>}
            </div>
        </>
    );

    const BottleSection = () => (
        <div>
            <p style={sectionLabel}>Your Bottle</p>
            {/* Size */}
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px', alignItems: 'center' }}>
                <span style={ratingLabel}>Size</span>
                {editingSize ? (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <input type="number" value={newSize} onChange={e => setNewSize(e.target.value)} placeholder="e.g. 100" style={{ width: '56px', background: '#0a0a0a', border: '1px solid #c9a96e', color: '#f5f0eb', fontFamily: 'Jost, sans-serif', fontSize: '0.75rem', padding: '4px 8px', textAlign: 'center' }} />
                        <span style={{ color: '#a09890', fontSize: '0.7rem', fontFamily: 'Jost, sans-serif' }}>ml</span>
                        <span onClick={handleSaveSize} style={{ color: '#c9a96e', fontSize: '0.65rem', fontFamily: 'Jost, sans-serif', letterSpacing: '0.2em', textTransform: 'uppercase', cursor: 'pointer' }}>Save</span>
                    </div>
                ) : (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <span style={{ fontFamily: 'Jost, sans-serif', fontSize: '0.7rem', color: '#a09890' }}>{item.bottle_size_ml ? `${item.bottle_size_ml}ml` : '—'}</span>
                        <span onClick={() => setEditingSize(true)} style={{ color: '#665e58', fontSize: '0.6rem', fontFamily: 'Jost, sans-serif', letterSpacing: '0.2em', textTransform: 'uppercase', cursor: 'pointer' }}>Edit</span>
                    </div>
                )}
            </div>
            {/* Remaining */}
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px', alignItems: 'center' }}>
                <span style={ratingLabel}>Remaining</span>
                {editingBottle ? (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <input type="number" min="0" max="100" value={newPct} onChange={e => setNewPct(Number(e.target.value))} style={{ width: '56px', background: '#0a0a0a', border: '1px solid #c9a96e', color: '#f5f0eb', fontFamily: 'Jost, sans-serif', fontSize: '0.75rem', padding: '4px 8px', textAlign: 'center' }} />
                        <span style={{ color: '#a09890', fontSize: '0.7rem', fontFamily: 'Jost, sans-serif' }}>%</span>
                        <span onClick={handleSavePct} style={{ color: '#c9a96e', fontSize: '0.65rem', fontFamily: 'Jost, sans-serif', letterSpacing: '0.2em', textTransform: 'uppercase', cursor: 'pointer' }}>Save</span>
                    </div>
                ) : (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <span style={{ fontFamily: 'Jost, sans-serif', fontSize: '0.7rem', color: newPct <= 30 ? '#e07070' : '#c9a96e' }}>{newPct}%</span>
                        <span onClick={() => setEditingBottle(true)} style={{ color: '#665e58', fontSize: '0.6rem', fontFamily: 'Jost, sans-serif', letterSpacing: '0.2em', textTransform: 'uppercase', cursor: 'pointer' }}>Edit</span>
                    </div>
                )}
            </div>
            <div style={{ height: '2px', background: '#2a2a2a' }}>
                <div style={{ height: '2px', background: newPct > 30 ? '#c9a96e' : '#e07070', width: `${newPct}%`, transition: 'width 0.3s ease' }} />
            </div>
        </div>
    );

    const RightContent = () => (
        <>
            {(item.longevity || item.sillage) && (
                <div>
                    <p style={sectionLabel}>Performance</p>
                    {item.longevity && <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}><span style={ratingLabel}>Longevity</span><div>{ratingDots(item.longevity)}</div></div>}
                    {item.sillage && <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}><span style={ratingLabel}>Sillage</span><div>{ratingDots(item.sillage)}</div></div>}
                </div>
            )}
            {(seasons.length > 0 || occasions.length > 0) && (
                <div>
                    <p style={sectionLabel}>Best Worn</p>
                    <div style={{ marginBottom: '6px' }}>{seasons.map((s, i) => tag(s, i))}</div>
                    <div>{occasions.map((o, i) => tag(o, i))}</div>
                </div>
            )}
            <BottleSection />
        </>
    );

    return (
        <div
            onClick={handleOverlayClick}
            style={{
                position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)',
                zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center',
                padding: isMobile ? '0' : '24px', backdropFilter: 'blur(4px)',
            }}
        >
            <div style={{
                background: '#111111',
                border: isMobile ? 'none' : '1px solid #2a2a2a',
                width: '100%', maxWidth: '780px', position: 'relative',
                display: 'flex', flexDirection: 'column',
                height: isMobile ? '100vh' : 'auto',
                maxHeight: isMobile ? '100vh' : '90vh',
                overflowY: 'auto',
            }}>

                {/* Close */}
                <button onClick={onClose} style={{ position: 'absolute', top: '16px', right: '16px', background: 'none', border: 'none', color: '#a09890', fontSize: '1.1rem', cursor: 'pointer', zIndex: 1 }}>✕</button>

                {/* Header */}
                <div style={{ padding: headerPad, borderBottom: '1px solid #2a2a2a' }}>
                    <p style={{ fontFamily: 'Jost, sans-serif', fontSize: '0.6rem', letterSpacing: '0.4em', textTransform: 'uppercase', color: '#c9a96e', marginBottom: '8px' }}>{item.brand}</p>
                    <p style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: isMobile ? '1.7rem' : '2rem', fontWeight: 300, color: '#f5f0eb', lineHeight: 1.1, marginBottom: '8px', paddingRight: '36px' }}>{item.name}</p>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                        {item.type && <span style={{ fontFamily: 'Jost, sans-serif', fontSize: '0.7rem', fontWeight: 300, color: '#a09890', letterSpacing: '0.1em' }}>{item.type}</span>}
                        {item.main_accord && tag(item.main_accord, 0)}
                    </div>
                </div>

                {/* Body — two columns desktop, stacked mobile */}
                {isMobile ? (
                    <div>
                        <div style={{ padding: pad, borderBottom: '1px solid #2a2a2a' }}>
                            <NotesContent />
                        </div>
                        <div style={{ padding: pad, display: 'flex', flexDirection: 'column', gap: '24px' }}>
                            <RightContent />
                        </div>
                    </div>
                ) : (
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1px 1fr' }}>
                        <div style={{ padding: pad }}><NotesContent /></div>
                        <div style={{ background: '#2a2a2a' }} />
                        <div style={{ padding: pad, display: 'flex', flexDirection: 'column', gap: '24px' }}><RightContent /></div>
                    </div>
                )}

                {/* Footer */}
                <div style={{ padding: isMobile ? '16px 20px' : '20px 40px', borderTop: '1px solid #2a2a2a', display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '12px' }}>
                    {confirmDelete ? (
                        <>
                            <span style={{ ...ratingLabel, marginRight: 'auto', fontSize: '0.75rem' }}>Remove from library?</span>
                            <button onClick={() => setConfirmDelete(false)} style={{ background: 'none', border: '1px solid #2a2a2a', color: '#a09890', fontFamily: 'Jost, sans-serif', fontSize: '0.65rem', letterSpacing: '0.2em', textTransform: 'uppercase', padding: '10px 20px', cursor: 'pointer' }}>Cancel</button>
                            <button onClick={() => { onDelete(item.id); onClose(); }} style={{ background: 'none', border: '1px solid #e07070', color: '#e07070', fontFamily: 'Jost, sans-serif', fontSize: '0.65rem', letterSpacing: '0.2em', textTransform: 'uppercase', padding: '10px 20px', cursor: 'pointer' }}>Confirm</button>
                        </>
                    ) : (
                        <button
                            onClick={() => setConfirmDelete(true)}
                            onMouseEnter={e => e.currentTarget.style.background = 'rgba(224,112,112,0.08)'}
                            onMouseLeave={e => e.currentTarget.style.background = 'none'}
                            style={{ background: 'none', border: '1px solid #e07070', color: '#e07070', fontFamily: 'Jost, sans-serif', fontSize: '0.65rem', letterSpacing: '0.2em', textTransform: 'uppercase', padding: '10px 24px', cursor: 'pointer', transition: 'background 0.3s ease', width: isMobile ? '100%' : 'auto' }}
                        >Remove from Library</button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default FragranceModal;